const details = {

  // Environmental variable
  graphqlEndpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT,
  region: process.env.REACT_APP_REGION,
}
export default details
